import { z } from 'zod';
import { PERFIS } from '../permissoes/tipos.js';
import { zEmail, zSenha } from './auth.js';
import { zFuso } from './configuracoes.js';
import { zSlugDeArena } from './primitivos.js';
/**
 * Os contratos do painel da plataforma: criar arena, dar a ela um dono
 * e vincular pessoas.
 *
 * Nada aqui é tela de arena. Quem usa é o administrador da plataforma,
 * com a mesma credencial do operador (`Authorization: Operador …`) —
 * fora do aplicativo, sem sessão de arena e sem linha na matriz. Um
 * perfil "super-usuário" DENTRO da matriz seria o bypass que a
 * arquitetura evita: aqui a porta é outra, e é uma só.
 */
const zNome = z.string().trim().min(2, 'Informe o nome.').max(120, 'No máximo 120 caracteres.');
export const zPerfilDeSistema = z.enum(PERFIS);
/**
 * A pessoa a vincular. A senha só é exigida quando o e-mail ainda não
 * existe: a mesma pessoa pode estar em duas arenas, e vincular de novo
 * não troca a senha de ninguém.
 */
export const zPessoaDaPlataforma = z.object({
    nome: zNome,
    email: zEmail,
    senha: zSenha.optional(),
});
/** `POST /plataforma/arenas` — a arena nasce com o dono. */
export const zNovaArenaDaPlataforma = z.object({
    nome: zNome,
    slug: zSlugDeArena,
    fuso: zFuso.optional(),
    dono: zPessoaDaPlataforma,
});
/** `POST /plataforma/arenas/:id/membros` */
export const zNovoMembroDaPlataforma = zPessoaDaPlataforma.extend({
    perfil: zPerfilDeSistema,
});
//# sourceMappingURL=plataforma.js.map